import { Store as VuexStore } from 'vuex';
import { State, createState } from './state';
import { createGetters } from './getters';
import { createMutations } from './mutations';
import { createActions } from './actions';

export class Store extends VuexStore<State> {}

export type StorePlugin = (store: Store) => void;
export type StoreOptions = { plugins: StorePlugin[] };

export function createStore(options: StoreOptions): Store {
  return new Store({
    state: createState(),
    getters: createGetters(),
    mutations: createMutations(),
    actions: createActions(),
    ...options
  });
}
